import Vue from 'vue';
import App from './App.vue';
import {router} from './router/index.js';
import store from './store/index.js';
import { heading } from '@/assets/resources/mixin';
import '@/assets/styles/common/loading.css'

Vue.config.productionTip = false
Vue.prototype.$heading = heading

// Netfunnel 버전 업그레이드로 현재 사용 버전 제거 - 추후 업그레이드 버전으로 작업 예정
// import Netfunnel from '@/plugins/netfunnel.js'
// import emartSkin from '@/plugins/emart_skin.js'

// Vue.use(Netfunnel)
// Vue.use(emartSkin)

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
